import { checkRoleManager } from '@/helpers/roles'

export function managerHasHubs(user) {
  if (!checkRoleManager(user.role)) return false

  for (let entity of user.entities) {
    if (entity.hubs.length > 1) return true
  }

  return false
}



// WEBPACK FOOTER //
// ./src/helpers/managers.js